// Konfidency REST API — raw HTTP layer
// Customer ID: nathof
// Base URL confirmada: https://reviews-api.konfidency.com.br
//
// ENDPOINTS:
//
// [1] Product reviews (paginated):
//   GET /nathof/{shopifyProductId}/summary/{sortField},{sortOrder}
//       ?page={n}&pageSize={n}
//   sortOrder: desc | asc  (NOT -1 or 1)
//   Example confirmado pela Konfidency:
//   https://reviews-api.konfidency.com.br/nathof/8316874719419/summary/helpfulScore,desc
//
// [2] Batch star ratings:
//   GET /nathof/ratings?skus={id1},{id2},...
//
// [3] Store reviews list:
//   GET /nathof/store-reviews/published/{sortField},{sortOrder}
//   Example: /nathof/store-reviews/published/created,desc
//
// [4] Store reviews summary:
//   GET /nathof/store-reviews/summary
//
// [5] Store carousel:
//   GET /nathof/store-reviews/carousel

const BASE = import.meta.env.VITE_KONFIDENCY_API_BASE as string;
const CUSTOMER = import.meta.env.VITE_KONFIDENCY_CUSTOMER_ID as string;

if (!CUSTOMER || CUSTOMER.trim() === '') {
  console.error(
    '[Konfidency] VITE_KONFIDENCY_CUSTOMER_ID não está definido no .env. ' +
    'Nenhum review será carregado. Valor correto: nathof'
  );
}

if (!BASE || BASE.trim() === '') {
  console.error(
    '[Konfidency] VITE_KONFIDENCY_API_BASE não está definido no .env. ' +
    'Valor correto: https://reviews-api.konfidency.com.br'
  );
}

async function apiFetch<T>(path: string): Promise<T> {
  const url = `${BASE}/${CUSTOMER}${path}`;

  if (import.meta.env.DEV) {
    console.log(`[Konfidency] → GET ${url}`);
  }

  const res = await fetch(url, {
    headers: { 'Accept': 'application/json' },
  });

  if (!res.ok) {
    const errorMsg = `[Konfidency] ✗ ${res.status} ${res.statusText} — ${url}`;
    console.error(errorMsg);
    throw new Error(errorMsg);
  }

  const data = await res.json();

  if (import.meta.env.DEV) {
    console.log(`[Konfidency] ✓ ${url}`, data);
  }

  return data as T;
}

export const konfidencyAdapter = {
  getProductReviews: (konfidencyId: string, page = 1, pageSize = 20, sort = 'helpfulScore,desc') =>
    apiFetch<unknown>(`/${konfidencyId}/summary/${sort}?page=${page}&pageSize=${pageSize}`),

  getProductRatings: (konfidencyIds: string[]) =>
    apiFetch<unknown>(`/ratings?skus=${konfidencyIds.join(',')}`),

  getStoreReviews: (sort = 'created,desc', page = 1, pageSize = 20) =>
    apiFetch<unknown>(`/store-reviews/published/${sort}?page=${page}&pageSize=${pageSize}`),

  getStoreSummary: () =>
    apiFetch<unknown>('/store-reviews/summary'),

  getStoreCarousel: () =>
    apiFetch<unknown>('/store-reviews/carousel'),
};
